import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';

// Angular Material Modules
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {MatCardModule} from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatStepperModule} from '@angular/material/stepper';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {NgxSpinnerModule} from 'ngx-spinner';
import {NgxOtpInputComponent} from 'ngx-otp-input';

// Components
import {ToolbarComponent} from '../web/components/toolbar/toolbar.component';
import {MatTableModule} from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {ButtonOutlineComponent} from '../web/components/button-outline/button-outline.component';
import {TranslateModule} from '@ngx-translate/core';
import {NewsletterInputComponent} from '../web/components/input/newsletter-input.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {QuoteListItemComponent} from '../web/components/card/quote-list-item/quote-list-item.component';
import {ClinicInclusionsComponent} from '../web/components/card/clinic-inclusions/clinic-inclusions.component';
import {
  ClinicListItemCompactComponent
} from '../web/components/card/clinic-list-item/compact/clinic-list-item-compact.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {UrandaUiModule} from '@uranda/ui';
import {AwaitingQuotesComponent} from '../web/components/card/awaiting-quotes/awaiting-quotes.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {
  QuoteActionTableComponent
} from '../partners/clinic-control-panel/components/quote-action-table/quote-action-table.component';
import {RouterModule} from '@angular/router';
import {FormlyGooglePlacesComponent} from '../web/components/formly-types/google-places-autocomplete.type';
import {OtpComponent} from '../web/components/otp/otp.component';
import {ClinicJoinDisclaimerComponent} from '../web/components/clinic-join-disclaimer/clinic-join-disclaimer.component';
import {NgOtpInputModule} from 'ng-otp-input';
import {RequestComponent} from '../web/request/request.component';
import {FormlyMultiSelectComponent} from '../web/components/formly-types/multi-select.type';
import {NgSelectModule} from '@ng-select/ng-select';
import {MultiSocialInputComponent} from '../web/components/formly-types/company-socials.type';
import {FormlyFieldFile} from '../web/components/formly-types/file-type/file-type.component';
import {FileValueAccessor} from '../web/components/formly-types/file-type/file-type-accessor';
import {FloatingContactFormComponent} from '../web/components/floating-contact-form/floating-contact-form.component';
import {PhoneTypeComponent} from '../web/components/formly-types/phone-type/phone-type.component';
import {SwitchTypeComponent} from '../web/components/formly-types/switch-type';
import {PaymentMethodComponent} from '../web/components/formly-types/payment-method.type';
import {InsertOtpModalComponent} from '../web/insert-otp-modal/insert-otp-modal.component';
import {FormlyGeonamesAutocompleteComponent} from '../web/components/formly-types/geonames.type';
import {VerifyRequestComponent} from '../web/verify-request/verify-request.component';
import {VerifyReviewComponent} from '../web/verify-review/verify-review.component';
import {VerifyNumberComponent} from '../web/request/verify-number/verify-number.component';
import {VerifyOtpComponent} from '../web/verify-otp/verify-otp.component';
import {CustomRadioDescriptionType} from '../web/components/formly-types/CustomRadioDescriptionType';
import {
  ImageListModalComponent
} from '../partners/clinic-control-panel/components/image-list-modal/image-list-modal.component';
import {
  ImageViewerModalComponent
} from '../partners/clinic-control-panel/components/image-viewer-modal/image-viewer-modal.component';
import {
  EnhancedImageIconComponent
} from '../partners/clinic-control-panel/components/enhanced-image-icon/enhanced-image-icon.component';
import {ReviewComponent} from '../partners/clinic-control-panel/components/review/review.component';
import {ReviewRowComponent} from '../partners/clinic-control-panel/components/review-row/review-row.component';
import {CountryNamePipe} from './pipes/country-name.pipe';
import {PlaceNamePipe} from './pipes/place-name.pipe';
import {LeadNamePipe} from './pipes/lead-name.pipe';
import {
  ReviewSummaryComponent
} from '../partners/clinic-control-panel/components/review-summary/review-summary.component';
import {
  RatingBreakdownComponent
} from '../partners/clinic-control-panel/components/rating-breakdown/rating-breakdown.component';
import {WriteReviewComponent} from '../web/components/write-review/write-review.component';
import {FormlyCountryAutocompleteComponent} from '../web/components/formly-types/formly-country-autocomplete';
import {RequestCardSelectionComponent} from '../web/components/request-card-selection/request-card-selection.component';
import {FormlyCardTypeComponent} from '../web/components/formly-types/formly-card-type.component';
import {RatingButtonsType} from '../web/components/formly-types/rating-buttons.component';
import {EmojiRatingType} from '../web/components/formly-types/emoji-rating.component';
import {
  UserProfileDropdownComponent
} from '../partners/clinic-control-panel/components/user-profile-dropdown/user-profile-dropdown.component';
import {ReviewSidebarComponent} from '../web/components/review-sidebar/review-sidebar.component';
import {WalletOffcanvasComponent} from '../web/components/wallet-offcanvas/wallet-offcanvas.component';
import {MobileSearchbarComponent} from '../web/components/mobile-searchbar/mobile-searchbar.component';
import {ImageGalleryComponent} from '../partners/clinic-control-panel/components/image-gallery/image-gallery.component';
import {
  ClinicListItemSkeletonComponent
} from '../web/components/card/clinic-list-item/skeleton/clinic-list-item-skeleton.component';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {SidebarBadgeComponent} from '../partners/clinic-control-panel/components/sidebar-badge/sidebar-badge.component';
import {
  PdfPreviewComponent
} from '../partners/clinic-control-panel/components/enhanced-image-icon/pdf-preview.component';
import {
  ContactsCardComponent
} from '../partners/clinic-control-panel/clinic-control-panel/contacts/contacts-card/contacts-card.component';
import {
  StatusDropdownComponent
} from '../partners/clinic-control-panel/components/status-dropdown/status-dropdown.component';
import {
  ConfirmationModalComponent
} from '../partners/clinic-control-panel/components/confirmation-modal/confirmation-modal.component';
import {
  LeadNameComponent,
  VerifiedIconComponent
} from '../partners/clinic-control-panel/clinic-control-panel/leads/leads.component';
import {
  SendQuoteButtonComponent
} from '../partners/clinic-control-panel/clinic-control-panel/partner-quotes/send-quote-button.component';
import {
  LanguageFlagsComponent
} from '../partners/clinic-control-panel/components/language-flags/language-flags.component';
import {RatingBadgeComponent} from '../web/components/rating-badge/rating-badge.component';
import {EmptyStateComponent} from '../partners/clinic-control-panel/components/empty-state/empty-state.component';
import {
  PartnerVerifiedIconComponent
} from '../partners/clinic-control-panel/clinic-control-panel/clinics/partner-verified-icon/partner-verified-icon.component';
import {TableRatingBadgeComponent} from '../web/components/rating-badge/table-rating-badge.component';
import {TableAvatarComponent} from '../partners/clinic-control-panel/components/table-avatar/table-avatar.component';
import {SwiperComponent} from '../partners/clinic-control-panel/components/swiper/swiper.component';
import {ReviewDetailsComponent} from '../web/components/review-details/review-details.component';
import {
  NotificationDropdownComponent
} from '../partners/clinic-control-panel/components/notification-dropdown/notification-dropdown.component';
import {
  FilterPopoverCustomComponent
} from '../partners/clinic-control-panel/components/filter-popover/filter-popover.component';
import {
  StickyMobileFooterComponent
} from '../partners/clinic-control-panel/components/sticky-mobile-footer/sticky-mobile-footer.component';
import {
  BooleanIconComponent
} from '../partners/clinic-control-panel/clinic-control-panel/partner-quotes/BooleanIconComponent';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {ShareIconsModule} from 'ngx-sharebuttons/icons';
import {MatTooltipModule} from '@angular/material/tooltip';

import {MatDialogModule} from '@angular/material/dialog';
import {
  QuoteEmptyStateComponent
} from '../web/components/card/quote-list-item/quote-empty-state/quote-empty-state.component';
import {
  PhoneNumberVerificationTextComponent
} from '../web/components/phone-number-verification-text/phone-number-verification-text.component';
import {OtpPageComponent} from '../web/otp-page/otp-page.component';

import {LinkPartnerButtonComponent } from '../partners/clinic-control-panel/qr-codes/link-partner-button/link-partner-button.component';
import {QrCodeModalComponent} from '../partners/clinic-control-panel/qr-codes/qr-code-modal/qr-code-modal.component';
import {WalletToolComponent} from '../partners/clinic-control-panel/components/wallet-tool/wallet-tool.component';
import {SubscriptionToolComponent} from '../partners/clinic-control-panel/components/subscription-tool/subscription-tool.component';
import {FormlyHorizontalWrapper} from '../web/components/formly-types/horizontal.wrapper';
import {
  PaginationRowComponent
} from '../partners/clinic-control-panel/components/pagination-row/pagination-row.component';
import {SidemenuComponent} from '../partners/clinic-control-panel/components/sidemenu/sidemenu.component';
import {ForgotPasswordComponent} from '../auth/login/forgotPassword/forgotPassword.component';
import {DynamicTabsComponent} from '../web/components/dynamic-tabs/dynamic-tabs.component';
import {VerificationBadgeComponent} from './components/verification-badge/verification-badge.component';
import {
  PartnerQuoteDetailsComponent
} from '../partners/clinic-control-panel/clinic-control-panel/partner-quotes/partner-quote-details/partner-quote-details.component';
import {ClinicDetailOffcanvasComponent} from '../web/components/clinic-detail/clinic-detail-modal.component';
import {LatestReviewsComponent} from '../web/components/clinic-detail/latest-reviews/latest-reviews.component';
import {ImageCropperComponent} from 'ngx-image-cropper';
import {ModalPlayerComponent} from "../web/request/modal-nav/modal-player.component";
import {ModalNavComponent} from "./components/modal-nav/modal-nav.component";
import {PublicCoreModule} from './public-core.module';

export async function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './public/assets/i18n/', '.json');
}

// Shared modules and components to be used across the app
const sharedModules = [
  NgbModule,
  CommonModule,

  ReactiveFormsModule,
  FormlyBootstrapModule,
  FormsModule,
  HttpClientModule,
  MatToolbarModule,
  MatIconModule,
  NgOtpInputModule,
  MatSidenavModule,
  MatButtonModule,
  MatListModule,
  MatCardModule,
  RouterModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatCheckboxModule,
  MatIconModule,
  MatGridListModule,
  MatCardModule,
  UrandaUiModule,
  MatMenuModule,
  NgxSpinnerModule,
  MatButtonModule,

  MatStepperModule,
  MatInputModule,
  MatSelectModule,
  MatPaginatorModule,
  NgSelectModule,
  MatSnackBarModule,
  InfiniteScrollDirective,
  ShareButtonsModule,
  ShareIconsModule,
  ImageCropperComponent,
  NgxOtpInputComponent
];

@NgModule({
  imports: [
    TranslateModule.forChild(),
    FormlyModule,
    ...sharedModules,
    MatTooltipModule,
    MatDialogModule,
    VerificationBadgeComponent,
    PublicCoreModule,
    CountryNamePipe,
    PlaceNamePipe,
    LeadNamePipe,
  ],
  declarations: [
    ToolbarComponent,
    ButtonOutlineComponent,
    ClinicListItemCompactComponent,
    ClinicListItemSkeletonComponent,
    QuoteListItemComponent,
    ClinicInclusionsComponent,
    QuoteActionTableComponent,
    NewsletterInputComponent,
    FormlyGooglePlacesComponent,
    OtpComponent,
    AwaitingQuotesComponent,
    ClinicJoinDisclaimerComponent,
    RequestComponent,
    ModalPlayerComponent,
    FormlyMultiSelectComponent,
    MultiSocialInputComponent,
    FormlyFieldFile,
    FormlyGeonamesAutocompleteComponent,
    FileValueAccessor,
    FloatingContactFormComponent,
    PhoneTypeComponent,
    SwitchTypeComponent,
    PaymentMethodComponent,
    InsertOtpModalComponent,
    VerifyRequestComponent,
    VerifyReviewComponent,
    VerifyNumberComponent,
    VerifyOtpComponent,
    CustomRadioDescriptionType,
    ImageListModalComponent,
    ImageViewerModalComponent,
    EnhancedImageIconComponent,
    PhoneNumberVerificationTextComponent,
    ReviewComponent,
    ReviewRowComponent,
    PaginationRowComponent,
    ReviewSummaryComponent,
    RatingBreakdownComponent,
    WriteReviewComponent,
    FormlyCountryAutocompleteComponent,
    RequestCardSelectionComponent,
    FormlyCardTypeComponent,
    RatingButtonsType,
    EmojiRatingType,
    UserProfileDropdownComponent,
    ModalNavComponent,
    ReviewSidebarComponent,
    WalletOffcanvasComponent,
    MobileSearchbarComponent,
    ImageGalleryComponent,
    SidebarBadgeComponent,
    PdfPreviewComponent,
    ContactsCardComponent,
    StatusDropdownComponent,
    ConfirmationModalComponent,
    VerifiedIconComponent,
    LeadNameComponent,
    SendQuoteButtonComponent,
    ReviewDetailsComponent,
    LanguageFlagsComponent,
    RatingBadgeComponent,
    EmptyStateComponent,
    SwiperComponent,
    PartnerVerifiedIconComponent,
    TableRatingBadgeComponent,
    TableAvatarComponent,
    NotificationDropdownComponent,
    FilterPopoverCustomComponent,
    BooleanIconComponent,
    StickyMobileFooterComponent,
    QuoteEmptyStateComponent,
    OtpPageComponent,
    LinkPartnerButtonComponent,
    QrCodeModalComponent,
    WalletToolComponent,
    SubscriptionToolComponent,
    FormlyHorizontalWrapper,
    SidemenuComponent,
    ForgotPasswordComponent,
    DynamicTabsComponent,
    PartnerQuoteDetailsComponent,
    ClinicDetailOffcanvasComponent,
    LatestReviewsComponent,
  ],
  exports: [
    ...sharedModules,
    PublicCoreModule,
    ClinicListItemCompactComponent,
    ClinicListItemSkeletonComponent,
    QuoteListItemComponent,
    ClinicInclusionsComponent,
    NewsletterInputComponent,
    OtpComponent,
    FloatingContactFormComponent,
    ImageListModalComponent,
    ModalPlayerComponent,
    ModalNavComponent,
    ImageViewerModalComponent,
    EnhancedImageIconComponent,
    ReviewComponent,
    CountryNamePipe,
    PlaceNamePipe,
    LeadNamePipe,
    ReviewRowComponent,
    PaginationRowComponent,
    ReviewSummaryComponent,
    RatingBreakdownComponent,
    WriteReviewComponent,
    RequestCardSelectionComponent,
    UserProfileDropdownComponent,
    ReviewSidebarComponent,
    WalletOffcanvasComponent,
    MobileSearchbarComponent,
    ImageGalleryComponent,
    SidebarBadgeComponent,
    SendQuoteButtonComponent,
    ReviewDetailsComponent,
    ContactsCardComponent,
    StatusDropdownComponent,
    ConfirmationModalComponent,
    VerifiedIconComponent,
    PdfPreviewComponent,
    LanguageFlagsComponent,
    RatingBadgeComponent,
    EmptyStateComponent,
    SwiperComponent,
    AwaitingQuotesComponent,
    PartnerVerifiedIconComponent,
    TableRatingBadgeComponent,
    TableAvatarComponent,
    NotificationDropdownComponent,
    FilterPopoverCustomComponent,
    BooleanIconComponent,
    StickyMobileFooterComponent,
    QuoteEmptyStateComponent,
    OtpPageComponent,
    LinkPartnerButtonComponent,
    QrCodeModalComponent,
    WalletToolComponent,
    SubscriptionToolComponent,
    SidemenuComponent,
    DynamicTabsComponent,
    VerificationBadgeComponent,
    PartnerQuoteDetailsComponent,
    LatestReviewsComponent,
    LeadNameComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
}
